import type { ReactNode } from 'react';
import { Layout } from 'ui';
import { AppLogo } from '../app-layout/app-logo';

type P = {
  children?: ReactNode;
};

const { Content, Header } = Layout;

const GuestLayout = ({ children }: P) => (
  <Layout className="guest-layout">
    <Header className="guest-layout__header">
      <AppLogo />
    </Header>
    <Content className="guest-layout__content">{children}</Content>
  </Layout>
);

export default GuestLayout;
